<template>
  <div class="travelSpecsLog">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>日志列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <span>修改内容:</span>
      <el-select v-model="list.logType" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="gettravelSpecsLog()">查找</el-button>
      <el-button type="primary" @click="$router.go(-1)">返回</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        align="center"
        prop="hotelLogId"
        label="日志id"
        width="width"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="strType"
        label="修改内容"
        width="width"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="masterName"
        label="修改人"
        width="width"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="hotelAddTime"
        label="修改时间"
        width="width"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" width="width">
        <template slot-scope="{ row }">
          <el-button
            type="primary"
            size="mini"
            @click="$router.push(`/travelSpecsLogDetails/${row.hotelLogId}`)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="list.currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="list.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { travelSpecsLog } from "../../api/travelSpecs";
export default {
  name: "travelSpecsLog",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      tableData: [],
      pagination: {},
      options: [
        {
          value: -1,
          label: "全部",
        },
        {
          value: 1,
          label: "新增",
        },
        {
          value: 2,
          label: "上下架",
        },
        {
          value: 3,
          label: "套餐名称",
        },
        {
          value: 4,
          label: "房间数量",
        },
        {
          value: 5,
          label: "入住天数",
        },
        {
          value: 6,
          label: "第一晚入住房间Id",
        },
        {
          value: 7,
          label: "第二晚入住房间Id",
        },
        {
          value: 8,
          label: "第三晚入住房间Id",
        },
        {
          value: 9,
          label: "第四晚入住房间Id",
        },
        {
          value: 10,
          label: "第五晚入住房间Id",
        },
        {
          value: 11,
          label: "第六晚入住房间Id",
        },
        {
          value: 12,
          label: "排序",
        },
        {
          value: 13,
          label: "日历价格",
        },
      ],
      list: {
        specsId: Number(this.id),
        currentPage: 1,
        pageSize: 5,
        logType: null,
      },
    };
  },
  created() {
    this.gettravelSpecsLog();
  },
  methods: {
    async gettravelSpecsLog() {
      const { data } = await travelSpecsLog(this.list);
      this.tableData = data.list;
      this.pagination = data.pagination;
    },
    handleSizeChange(size) {
      this.list.pageSize = size;
      this.gettravelSpecsLog();
    },
    handleCurrentChange(num) {
      this.list.currentPage = num;
      this.gettravelSpecsLog();
    },
  },
};
</script>
<style lang="less" scoped>
.travelSpecsLog {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  .search {
    margin-top: 50px;
    .el-select {
      margin: 0 40px 0 20px;
    }
  }
  .el-table {
    margin-top: 50px;
  }
  .el-pagination {
    margin-top: 50px;
    float: right;
  }
}
</style>